import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { SearchGroupType, SearchResponse } from './types';
import type { PetSpecies } from '@/features/pet/types';

/**
 * Cross-catalogue search.
 *
 * `enabled` on a 2-character floor because that is the server's minimum too —
 * firing a request it will refuse with a 422 would only paint an error while
 * someone is still typing the first letter.
 */
export function use_search(
  q: string,
  opts: { lat?: number; lng?: number; group?: SearchGroupType; limit?: number; species?: PetSpecies } = {},
) {
  const query = q.trim();
  return useQuery({
    queryKey: ['search', query, opts.group ?? null, opts.species ?? null, opts.limit ?? null, opts.lat ?? null, opts.lng ?? null],
    queryFn: async () => {
      const params: Record<string, string | number> = { q: query };
      if (opts.lat != null && opts.lng != null) {
        params.lat = opts.lat;
        params.lng = opts.lng;
      }
      if (opts.group) params.group = opts.group;
      // Client change, 9 Oct 2026: the pet chip.
      if (opts.species) params.species = opts.species;
      if (opts.limit) params.limit = opts.limit;
      return (await api.get<SearchResponse>('/user/search', { params })).data;
    },
    enabled: query.length >= 2,
    // Keep the previous results on screen while the next ones load, so the list
    // doesn't blank out on every keystroke.
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
}
